import {IFetchContext} from "@pg-mono/data-fetcher";

import {cmsPageSections} from "../../admin_page/api/get_page_section";
import {rpApi} from "../../app/api/rp_api";
import {BRAND_NAME} from "../../app/constants/company";
import {IRPRequestMeta} from "../../app/rp_request_meta";
import {concatWithBrandName} from "../../app/utils/concat_with_brand_name";
import {MetaDataDispatch, updateMetaData} from "../../meta_data/actions/update_meta_data";
import {IAppDispatch} from "../../store/store";
import {fetchTestimonials} from "../api/fetch_testimonials";

export const ourOfferAction = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: IAppDispatch) => {
    await fetchTestimonials(ctx)(dispatch);
    updateOurOfferMetaData(ctx)(dispatch);
    await fetchPageSections(ctx)(dispatch);

    await Promise.all(dispatch(rpApi.util.getRunningQueriesThunk()));

    return true;
};

const fetchPageSections = (_ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: IAppDispatch) => {
    await dispatch(cmsPageSections.endpoints.getPageSection.initiate({slug: "dla-dewelopera"})).unwrap();
};

const updateOurOfferMetaData = (ctx: IFetchContext<IRPRequestMeta>) => (dispatch: MetaDataDispatch) => {
    const title = `Oferta dla dewelopera - ${BRAND_NAME}`;
    const description = `Zwiększ sprzedaż mieszkań dzięki skutecznej promocji ${concatWithBrandName("na portalu")}.`;
    dispatch(updateMetaData({title, description, pathname: ctx.route.pathname}));
};
